/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    value: 'Value',
    ok: 'Ok',
  },
  creators: {
    seeViewBy: 'See view by:'
  },
  lang: {
    changeMessage: 'We adapt the content to the selected language.',
  },
  anteroom: {
    startSeriesFor: 'Start series for:',
    startSeasonFor: 'Start season {{seasonNumber}} for:',
  },
  translations: {

    /**
     * COMMON
     */
    goToHome: "Go to home",
    spanish: "Spanish",
    english: "English",
    enterEmail: "Enter your e-mail",
    creators: "Creators",
    watchNow: "Watch now",
    download: "Download",
    downloadApp: 'Download app',
    back: "Back",
    series: "SERIES",
    community: "COMMUNITY",
    logout: "LOG OUT",
    episode: "EPISODE",
    min: "min",
    faqs: "FAQS",
    o: 'or',
    accept: 'Accept',
    cancel: 'Cancel',
    language: 'Language',
    content: 'Content',
    contents: 'Contents',
    linkCopied: 'Link copied',

    /**
     * MODAL
     */
    modal_enjoyYourContent_title: "Enjoy your content",
    modal_enjoyYourContent_content: "Get to know all the features in our app",
    modal_spendFlixx_title: "Spend your Flixx",
    modal_spendFlixx_content: "See the content you really want to see.",
    scanCodeQR: "Scan the QR code and access Flixxo",
    fromYourMobilePhone: "from your mobile phone!",
    availableOn: "Available on",
    liveFullExperience: "Live the full experience!",

    /**
     * FLIXX
     */
    useFlixx: "Save your Flixx and use them outside the app",
    buySellFlixx: "Buy and sell your flixx. Transform them into bitcoin or your currency",
    earnFlixx: "Earn Flixx",
    earnFlixxDescription: "Syndicating content or watching advertising whenever you want.",
    spendFlixx: "Spend Flixx",
    spendFlixxDescription: "See the content you really want to see.",
    withdrawFlixx: "Withdraw Flixx",
    withdrawFlixxDescription: "Transforming them into your preferred currency and use them outside the app.",
    howMuchFlixx: "How much is a Flixx?",
    flixxDescription: "Nothing screams 80`s more than tokens, but they`re back in fashion here in Flixxo. Using the Bitcoin technology, we were able to develop our own digital currency: the FLIXX. Not only you can earn it and exchange it for Bitcoin or your country`s currency, but you can also spend it watching videos or transfering it to your frends. You own Flixx and it`s yours to spend in any way you want, either in, or outside the app. ",

    /**
     * FOOTER
     */
    whatIsFlixx: "What is a Flixx?",
    termsAndConditions: "Terms and conditions",
    policyPrivacy: "Privacy policies",
  
    /**
     * SEARCH
     */
    "search-placeholder": "Search in Flixxo",
    "search-results": "Your results for:",

    /**
     * MOODS
     */
    "mood-cry": "Cry",
    "mood-fall": "Fall in love",
    "mood-laugh": "Laugh",
    "mood-imagine": "Imagine",
    "mood-scream": "Scream",
    "mood-think": "Think",
    moodsDescription: 'Discover the content filtering by moods',

    /**
     * NEW MESSAGES
     */
    retry: 'Retry',
    loginPlaceholder: 'E-mail or username',
    openApp: 'OPEN IN THE APPLICATION',
    backToPlay: 'Back to Play Flixxo',
    goToCreators: 'Go to Flixxo Creators',
    showDetail: 'Show detail',
    sendCode: 'Send code',
    enterPhone: 'Enter your phone number',
    enterCode: 'Enter here the code',
    newPassword: 'New password',
    confirmPassword: 'Confirm your password',
    didNotGetCode: 'Did not get the code?',
    sendAgain: 'Send again',
    enter: 'Enter',
    episodes: 'episodes',
    bought: 'Bought',
    watchFor: 'Watch for',
    watchSE: 'Watch S{{season}} E{{episode}}',
    season: 'Season',
    seasons: 'Seasons',
    subtitles: 'Subtitles',
    audio: 'Audio',
    video: 'Video',
    videos: 'Videos',
    showMore: 'Show more',
    showLess: 'Show less',
    disabledPlural: 'Disabled',
    nextEpisode: 'Next episode',
    starting: 'Starting',
    continueWatching: "Continue watching",
    didYouEnterWrongNumber: 'Did you enter a wrong number?',
    selectOption: 'Select an option',
    next: 'Next',
    timeAgo: '{{number}} {{unit}} ago',
    enjoyFullExperience: 'Enjoy the full expererience with our app',
    open: 'Open',
    continueOnBrowser: 'Continue on browser',

    statistics: 'Statistics',
    newFollowers: 'New Followers',
    status: "Status",
    releaseDate: 'Release Date',
    purchases: 'Purchases',
    earnings: "Earnings",
    price: "Price",

    /**
     * MODALS WELCOME, LOGIN, REGISTER, RECOVERY
     */
    welcomeToFlixxo: 'Welcome to Flixxo!',
    discoverBestMicroseries: 'Discover the best microseries around the world,',
    free: 'free.',
    enterWith: 'Enter with',
    alsoYouCan: 'Or also you can',
    login: 'Sign in',
    loggingIn: 'Signing in...',
    createAccount: 'Create account',
    creatingAccount: 'Creating account...',
    goodToSeeYouAgain: 'Good to see you again!',
    fillInYourDetails: 'Fill in your details to enter.',
    usernameOrEmail: 'Username or e-mail',
    password: 'Password',
    forgotMyPassword: 'Forgot my password',
    firstTimeInFlixxo: 'First time in Flixxo?',
    createYourAccount: 'Create your account',
    recoverPassword: 'Recover password',
    recoveringPassword: 'Recovering password...',
    enterYourMobileNumber: 'Enter your mobile number',
    mobileNumber: 'Mobile number',
    mobileInfo: 'Your phone number is required as a second security factor so that you can recover your password.',
    passwordsDoesntMatch: "Passwords doesn't match",
    enterCodeAndCreateNewPwd: 'Enter the code we sent you and create the new password',
    resendCode: 'Resend code',
    repeatPassword: 'Repeat password',
    passwordReqs: 'It must contain at least one lowercase, one uppercase, and one number. At least 8 characters long, no more than 30 characters.',
    passwordRecoverySuccessfull: 'Password succesfully recovered!',
    nowYouCanLoginWithNewPwd: 'Now you can sign in with the new password',
    great: 'Great',
    enterEmailAndCreateNewUsername: 'Enter an e-mail and create a username',
    email: 'E-mail',
    username: 'Username',
    usernameReq_1: 'Username must be 3 to 16 characters long.',
    usernameReq_2: 'Username must contain at least 1 letter.',
    termsAndConditions_1: 'By clicking the "Next" button below you are accepting our ',
    termsAndConditions_2: 'terms and conditions',
    termsAndConditions_3: ', our ',
    termsAndConditions_4: 'privacy policies',
    termsAndConditions_5: ' and that you are above 13 years old.',
    alreadyHaveAnAccount: 'Already have an account?',
    loginImperative: 'Log in',
    createPassword: 'Create a password',
    mustContainOneLowerCase: 'Must contain at least one lower case',
    mustContainOneUpperCase: 'Must contain at least one upper case',
    mustContainOneNumber: 'Must contain at least one number',
    lengthMinMax: 'Must be {{min}} to {{max}} characters long',
    congratsHaveCreatedAnAccount: 'Congrats! \n You have created an account',
    nowYouAreFlixxer: 'Now you are a Flixxer! 🤘',
    validateAccount: 'Validate account',
    validatingAccount: 'Validating account...',
    finishAccountValidation: 'Finish the validation of your account by entering your mobile number',
    enterCodeSentTo: 'Enter the code sent to:\n{{mobileNumber}}',
    recaptchaStatement_1: 'This site is protected by reCAPTCHA and the Google',
    recaptchaStatement_2: 'Privacy Policy',
    recaptchaStatement_3: 'and',
    recaptchaStatement_4: 'Terms of Service',
    recaptchaStatement_5: 'apply.',

    /**
     * FAQS
     */
    answersToCommonQuestions: 'Answers to the most frequently asked questions.',

    whatIsFlixxo: 'What is Flixxo?',
    whatIsFlixxo_1: 'Flixxo is a platform for microseries from around the world. The distribution and monetization model in Flixxo is different from everything that exists, since it allows:',
    whatIsFlixxo_2: 'To the viewers:',
    whatIsFlixxo_3: 'That they have an alternative to',
    whatIsFlixxo_4: ' find new voices and independent, and original content',
    whatIsFlixxo_5: ', that is, they do not depend on the algorithm.',
    whatIsFlixxo_6: 'That they can see in a short time, good stories.',
    whatIsFlixxo_7: 'To the creators:',
    whatIsFlixxo_8: 'That they can',
    whatIsFlixxo_9: ' monetize instantly and transparently.',

    whatKindOfContent: 'What kind of content do I find on Flixxo?',
    whatKindOfContent_1: 'Today at Flixxo you will find a diversity of microseries by emerging and independent creators that we discover at festivals around the world. Our curation is focused on new creative voices from all genres.',
    whatKindOfContent_2: ' Microseries are content of any genre, in which each episode last between 1 and 15 minutes.',

    howDoIAccess: 'How do I access to watch microseries on Flixxo?',
    howDoIAccess_1: 'It’s easy.',
    howDoIAccess_2: ' Register for free on the web or in the App ( ',
    howDoIAccess_3: ' ) and watch the content you like!',

    FlixxoIsFree: 'Flixxo is free?',
    FlixxoIsFree_1: 'Yes! At Flixxo',
    FlixxoIsFree_2: ' you can watch microseries for free.',
    FlixxoIsFree_3: 'There is also an alternative for those who do not want to see ads: load flixx in the wallet',
    FlixxoIsFree_4: ' (Only available in',
    FlixxoIsFree_5: ' App).',

    whatAreFlixx: 'What are the Flixx?',
    whatAreFlixx_1: 'Flixx is the crypto of our community. Thanks to the fact that we use Flixx, it is possible for creators to monetize in a direct, transparent and decentralized way every time you watch their content.',
    whatAreFlixx_2: 'Every time you watch content, the creator receives your Flixx.',
    whatAreFlixx_3: 'Every time you watch an ad, you receive Flixx.',
    whatAreFlixx_4: 'When you complete challenges, we reward you with Flixx.',
    whatAreFlixx_5: 'You can transfer Flixx to other users. ',
    whatAreFlixx_6: 'You can donate Flixx to content creators.',
    whatAreFlixx_7: 'You can also buy Flixx on exchanges like',
    whatAreFlixx_8: ' and load them into your wallet',
    whatAreFlixx_9: 'Learn more about Flixx',

    flixxGoToCreator: 'My flixx go directly to the creator?',
    flixxGoToCreator_1: 'Yes! Every time you watch content, the creator receives your Flixx instantly, transparently... and without intermediaries!',

    canUploadMyContent: 'I’m creator. Can I upload my content to Flixxo?',
    canUploadMyContent_1: "Of course. Come here, we'll tell you everything.",

    whatFlixxoMakesDifferent: 'What makes Flixxo different from other platforms?',
    whatFlixxoMakesDifferent_1: 'Short-term content.',
    whatFlixxoMakesDifferent_2: 'Transparent and direct support to the content creator.',
    whatFlixxoMakesDifferent_3: 'Promoter of emerging and independent creators to the market.',
    whatFlixxoMakesDifferent_4: 'Creative ecosystem between creators and viewers.',
    whatFlixxoMakesDifferent_5: 'Reward system.',
    whatFlixxoMakesDifferent_6: 'Algorithm free.',

    flixxoProduces: 'Flixxo produces?',
    flixxoProduces_1: 'The',
    flixxoProduces_2: ' Flixxo Originals',
    flixxoProduces_3: ' are the contents produced by Flixxo. At Flixxo Distribution, we support the creations of more than 30',
    flixxoProduces_4: ' creators 3.0',
    flixxoProduces_5: ' from around the world, and we promote them in international markets, looking for new platforms for their distribution.',

    whatAreCreators3: 'What are the Creators 3.0?',
    whatAreCreators3_1: 'Creators 3.0 are the protagonists of a new paradigm of collaborative and decentralized creativity, typical of the technology and culture of web 3.0.',
    whatAreCreators3_2: 'The fundamental value of web 3.0 is decentralization, that is, that there is no intermediary setting the rules. This gives the power back to the content creator to monetize directly.',

    haveDoubts: 'Do you have doubts?',
    faqs_contactUs: "contact us",

    /**
     * SEO
     */
    seoSeriesTitle: 'Series',
    seoSeriesDescription: 'Original short-form series from all around the world',
    seoCommunityTitle: 'Community',
    seoCommunityDescription: 'Short-form content & videos from Flixxo community',
    seoSearchTitle: 'Search',
    seoSearchDescription: 'Search for the best Flixxo content & videos',
    seoDefaultTitle: 'Flixxo',
    seoDefaultDescription: 'Short-form series and content in a web3 fashion',
    seoBeCreatorTitle: 'Be a creator',
    seoBeCreatorDescription: 'We support independent creators around the world in the production and distribution of their content.',
    seoFlixxTitle: 'Flixx, our cryptocurrency',
    seoFlixxDescription: 'Flixx is the cryptocurrency of Flixxo, use it to to watch microseries for free while supporting its creators at the same time.',

    /**
     * CREATORS
     */
    fromBeginning: 'From beginning',
    last30Days: 'Last 30 days',
    last7Days: 'Last 7 days',
    fromBeginningPhrase: `Since you uploaded your first content`,
    periodPhrase: `From {{ start }} to {{ end }}`,
    allContent: 'All content',

    noSearchResults: 'There are no results for your search',
    noSearchResultsDescription: 'Try searching another content',
    noContentYet: "You don't have any content yet",
    noContentYetDescription: 'Start to upload your content and create your own audience',
    noInternet: 'No internet connection',
    noInternetDescription: 'Check your connection and try again',
    serverError: 'Server error',
    serverErrorDescription: 'Please try again',

    searchYourVideo: 'Search your video...',
    viewOnFlixxo: 'View on Flixxo',
    published: 'Published',
    deleted: 'Deleted',
    paused: 'Paused',
    unknown: 'Unknown',

    seasonEpisode: 'S{{season}}E{{episode}}',
    earningsTooltip: 'Part of your income (purchases), is used to support the Community.',
    yourContentIsPaused: 'Your content is paused',
    knowMoreAboutContent: 'To know more about this content, contact us to content@flixxo.com',
    sendYourQuestion: 'Send your question',

    /**
     * ERROR MESSAGES
     */
    contentNotFound: `The content you are looking for doesn't exist`,
    wrongCredentials: 'Invalid username, e-mail or password.',
    emailRegistered: 'The e-mail entered is already registered.',
    emailInvalid: 'The e-mail entered has not a valid format.',
    usernameRegistered: 'The username entered is already registered.',
    passwordsDontMatch: `Passwords don't match`,
    mobileNumberInvalid: 'The mobile number entered is not valid',
    mobileNumberRegistered: 'The mobile number entered is already registered',
    mobileNumberUnknown: `The mobile number entered doesn't belong to any registered user`,
    codeInvalid: 'The code entered is not valid',
    operationLimitExceeded: 'Tries limit was exceeded. Please try again later.',
    notPossibleLogInThisAccount: 'Is not possible to log in with this account.',

    /**
     * Onboarding Anteroom
     */
    flixxoIsFree: 'Flixxo is free!',
    contentPricedInFlixx: 'All contents are priced in (*)Flixx(/*)',
    ifDontOwnFlixxWillPlayAd: `If you don't own any Flixx, (*)an ad will be played before the content.(/*)`,
    earnFlixxInChallengesSection: 'Download the App to find out how to earn more Flixx.',

    /**
     * Be CreatorfollowUpInteractions
     */
    creator: 'Creator',
    beCreator: 'I want to be a Creator 3.0',
    letsBoostYourMicroseries_1: `Let's boost`,
    letsBoostYourMicroseries_2: 'your microseries.',
    weSupportCreators: 'We support independent creators from all around the world during the production and distribution of their content.',
    globalMicroseries: '(*)Microseries(/*) from all around the world.',
    independentCreators: '(*)Independent creators(/*) who dare to disrupt the paradigm.',
    diverseContents: '(*)Diverse contents(/*) covering all kinds of subjects and genres.',
    weAdviceYou: `(*)You can count on our advice(/*) to improve your content's quality.`,
    canExpandYourReach: '(*)We can expand your reach(/*) in order to get to new markets and platforms.',
    yourContentYourRules: '(*)Your content, your rules.(/*) We are here to stand by your vision.',
    flixxoWelcomesYou: 'Flixxo welcomes you.',
    firstWeHugYou: `We understand the value and potential independent content holds, that is why the first thing you'll receive from us is a toast and a hug to welcome your series. From that moment on, our goal is to stand by your content.`,
    reachOutToUs: 'Reach out to us',
    showUsYourMicroseries: 'Show us your microseries.',
    addYourMicroseries: 'Add your microseries to the platform',
    workTogetherToPublish: `Once we have received your microseries we'll work together to show it on Flixxo.`,
    monetizeEachView: 'Monetize with each view',
    earnFlixxWithNoIntermediaries: `Each time someone watches one of your episodes, you'll earn Flixx tokens. You'll receive them directly from the audience, without any intermediaries.`,
    beProtagonist: 'Be at the center of your content and your community.',
    becomeCreator: 'Become a Creator 3.0',
    earnFlixxWithContentAccess: 'Each time someone access your content, you earn Flixx.',
    receiveFlixxInYourAccount: `Flixx is Flixxo 's cryptocurrency. Each time someone accesses your content you'll receive Flixx directly into your account.`,
    yourContent: 'Your content',
    followUpInteractions: `Follow up on your content's interactions in a detailed manner.`,
    yourEarnings: 'Your earnings',
    reviewAndFilterEarnings: 'Review and filter the evolution of your earnings.',
    readyToBecomeCreator: 'Are you ready to become a Creator 3.0?',
    anyQuestions: 'Any questions? Most likely they are covered in our',
    creatorTextChat: `Hi Flixxo! I have a microseries and a shortfilm that I would like to publish on their platform \uD83E\uDD0D`,
    flixxoTextChat: `Hi creator! cool! We love receiving proposals. Let's work together to publish it as soon as possible in Flixxo.`,

    /**
     * AD PLAYER
     */
    ad_title: 'Watching this ad will earn',
    ad_description: 'Then the creator will receive the flixx for the value of the episode and the content will start',

    /**
     * CONTENT PLAYER
     */
    creatorReceivingFlixx: 'The creator is receiving the flixx...',
    reproductionWillStartSoon: 'The reproduction will start soon...',
    seasonEpisodeHyphen: 'S{{season}}-E{{episode}}',

    /**
     * FLIXX
     */
    flixx_hero_whatIsFlixx: `Flixx is Flixxo's currency`,
    flixx_hero_description: `With Flixx, you'll be able to watch microseries for free while supporting creators. We borrowed Bitcoin's technology to create our own cryptocurrency, encouraging a fair, transparent monetization system. Flixx belong to you, the creators, our community, having value both inside and outside the platform.`,
    flixx_hero_imFlixx: 'Hi! I am Flixx',
    flixx_watchAd_title: 'Watch a short ad before playing content.',
    flixx_watchAd_description: 'The advertiser pays for your attention time.',
    flixx_watchAd_exampleTitle: 'Watching this ad you earn',
    flixx_watchAd_exampleDescription: 'Then the creator will get the flixx for the episode and the content will start',
    flixx_challenges_title: 'Complete challenges.',
    flixx_challenges_description: 'Discover new creators, invite your friends, watch series, win Flixx (access the challenges <0>downloading our mobile app</0>).',
    flixx_challenges_exampleTitle: 'The first of many to come...',
    flixx_challenges_exampleDescription: 'As a welcome gift, Flixx for your first view',
    flixx_challenges_examplePrize: 'Prize',
    flixx_challenges_exampleCTA: 'Claim reward',
    flixx_transfers_title: 'Receive Flixx from other users straight to your wallet.',
    flixx_transfers_description: `Send and receive Flixx without limits. You can donate to creators or get from a friend. You don't need to have any previous crypto knowledge! (To access the Wallet <0>download our mobile App</0>).`,
    flixx_transfers_exampleName: 'Alex',
    flixx_transfers_exampleDate: '2023-2-16',
    flixx_buy_title: 'Buy Flixx on an exchange',
    flixx_buy_description: 'You can buy and transfer Flixx to your wallet from <0>Uniswap</0>, <1>Bittrex</1>, <2>Bancor</2>.',
    flixx_doubts_title: 'Still any doubts about Flixx?',
    flixx_doubts_1_title: `Can I watch episodes if I don't have any Flixx?`,
    flixx_doubts_1_description: `(*)Yes. When you play an episode and you don't have any Flixx, a short ad will be displayed. (/*) Each ad will pay you enough Flixx to watch the episode and support its creator, who will get those Flixx in a transparent way.`,
    flixx_doubts_2_title: 'How much do the episodes cost?',
    flixx_doubts_2_description: 'Currently episodes cost 0.5 up to 1 Flixx. The ad played before the episode will pay you enough Flixx to watch the content.',
    flixx_doubts_3_title: 'What is the price of Flixx?',
    flixx_doubts_3_description: 'You can check Flixx price at <0>CoinMarketCap.</0>',
    flixx_doubts_4_title: 'Why does Flixxo use Flixx?',
    flixx_doubts_4_description: 'By using our own cryptocurrency we were able to create an ecosystem where advertisers, audience and content creators can interact and pay each other in an straight and transparent way, without any intermediaries.',
    flixx_doubts_faqs: 'Any doubts? <0>Contact us</0>.',

    /**
     * LANG
     **/    
    lang_modal_title: 'Do you want to change the language of Flixxo to {{lang}}?',
    lang_modal_description: 'We will adapt the content offer to the selected language',
  },
};
